const roomlive = {
    state:{
      // normal是普通直播，theatre是劇場模式，fullscreen是全屏模式
        playstauts:'normal',
        remenberplaystauts:'',
        chagenroomes:'close',
        skuObj:{},
        publickOnline:true
    },
    getters:{
      getSkuObj(state){
        return state.skuObj
      },
    },
    mutations:{
      setNet(state,data){
        state.publickOnline = data
      },
         // 这里是记住全屏和剧场模式的变量
      changeplaystauts(state,playstautss){
          state.remenberplaystauts = state.playstauts
          state.playstauts = playstautss
      },
      setremenberplaystauts(state,stauts){
        state.remenberplaystauts  = ''
      },
      chagenRoomes(state,change){
        state.chagenroomes = change
      },
      setSkuObj(state,skuObj){
        state.skuObj = skuObj
      },
    },
    actions:{
      
    }
}
export default roomlive